module.exports = __webpack_public_path__ + "img/v4.357f2d81.png";